import { TreeNode } from '@b2b/common/utils/tree-node';
import { input } from '@b2b/types/core';
import angular from 'angular';
import { TreeNodeDirectiveModule } from './tree-node.directive';

let id = 0;

export class TreeController<TModel = unknown> {
  static $inject = ['$element'];

  model = input<TModel>();

  nodeId = `acme-tree-${++id}`;
  node: TreeNode<TModel>;

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-tree');

    if (this.node) {
      this.node.id = this.node.id || this.nodeId;
      this.node.parent = null;
      this.node.value = this;
    } else {
      this.node = new TreeNode({
        id: this.nodeId,
        parent: null,
        children: [],
        value: this,
      });
    }
  }

  add(node: TreeNode<TModel>) {
    this.node.add(node);
  }
}

TreeDirective.$inject = [];

function TreeDirective() {
  return {
    restrict: 'A',
    bindToController: {
      node: '<',
      model: '<',
    },
    controllerAs: '$ctrl',
    controller: TreeController,
    link: function ($scope, $element, $attrs) {},
  };
}

export const TreeDirectiveModule = angular
  .module('acme.common.directive.tree', [TreeNodeDirectiveModule])
  .directive('acmeTree', TreeDirective).name;
